"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _rtc = _interopRequireDefault(require("./mixins/rtc.js"));
var _shareRtc = _interopRequireDefault(require("./mixins/share-rtc.js"));
var _libGenerateTestUsersigMin = _interopRequireDefault(require("@/views/trial/videoTrial/demo/components/utils/lib-generate-test-usersig.min.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "compRoom",
  mixins: [_rtc.default, _shareRtc.default],
  props: {
    type: String,
    sdkAppId: Number,
    secretKey: String,
    userId: String,
    roomId: Number,
    cameraId: String,
    microphoneId: String,
    inviteUserSig: String
  },
  data: function data() {
    return {
      logList: [],
      inviteLink: "",
      showCopiedTip: false
    };
  },
  computed: {
    isHostMode: function isHostMode() {
      return this.type !== "invite";
    },
    isEnLang: function isEnLang() {
      return this.$i18n.locale === "en";
    }
  },
  watch: {
    cameraId: function cameraId(val) {
      this.switchDevice("video", val);
    },
    microphoneId: function microphoneId(val) {
      this.switchDevice("audio", val);
    }
  },
  methods: {
    generateInviteLink: function generateInviteLink() {
      if (!this.isHostMode) {
        return;
      }
      var sdkAppId = this.sdkAppId,
        secretKey = this.secretKey,
        roomId = this.roomId;
      var inviteUserId = "user_".concat(parseInt(Math.random() * 100000000, 10));
      var userSigGenerator = new _libGenerateTestUsersigMin.default(sdkAppId, secretKey, 604800);
      var inviteUserSig = userSigGenerator.genTestUserSig(inviteUserId);
      this.inviteLink = encodeURI("".concat(location.origin).concat(location.pathname, "#/invite?sdkAppId=").concat(sdkAppId, "&userSig=").concat(inviteUserSig, "&roomId=").concat(roomId, "&userId=").concat(inviteUserId));
    },
    handleCopyInviteLink: function handleCopyInviteLink() {
      var _this = this;
      navigator.clipboard.writeText(this.inviteLink);
      this.showCopiedTip = true;
      setTimeout(function () {
        _this.showCopiedTip = false;
      }, 1500);
      this.generateInviteLink();
    },
    // 点击【Join Room】按钮
    handleJoinRoom: function () {
      var _handleJoinRoom = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var userSigGenerator;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isHostMode) {
                _context.next = 11;
                break;
              }
              if (!(!this.sdkAppId || !this.secretKey)) {
                _context.next = 4;
                break;
              }
              alert("Please enter sdkAppId and secretKey");
              return _context.abrupt("return");
            case 4:
              if (!(!this.userId || !this.roomId)) {
                _context.next = 7;
                break;
              }
              alert("Please enter userId and roomId");
              return _context.abrupt("return");
            case 7:
              userSigGenerator = new _libGenerateTestUsersigMin.default(this.sdkAppId, this.secretKey, 604800);
              this.userSig = userSigGenerator.genTestUserSig(this.userId);
              _context.next = 15;
              break;
            case 11:
              if (!(!this.sdkAppId || !this.inviteUserSig || !this.userId || !this.roomId)) {
                _context.next = 14;
                break;
              }
              alert("Please reacquire the invitation link");
              return _context.abrupt("return");
            case 14:
              this.userSig = this.inviteUserSig;
            case 15:
              _context.next = 17;
              return this.initClient();
            case 17:
              _context.next = 19;
              return this.join();
            case 19:
              _context.next = 21;
              return this.initLocalStream();
            case 21:
              _context.next = 23;
              return this.playLocalStream();
            case 23:
              _context.next = 25;
              return this.publish();
            case 25:
              this.generateInviteLink();
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleJoinRoom() {
        return _handleJoinRoom.apply(this, arguments);
      }
      return handleJoinRoom;
    }(),
    // 点击【Publish】按钮
    handlePublish: function () {
      var _handlePublish = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.publish();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handlePublish() {
        return _handlePublish.apply(this, arguments);
      }
      return handlePublish;
    }(),
    // 点击【Unpublish】按钮
    handleUnpublish: function () {
      var _handleUnpublish = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.unPublish();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleUnpublish() {
        return _handleUnpublish.apply(this, arguments);
      }
      return handleUnpublish;
    }(),
    // 点击【Leave Room】按钮
    handleLeave: function () {
      var _handleLeave = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.leave();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleLeave() {
        return _handleLeave.apply(this, arguments);
      }
      return handleLeave;
    }(),
    // 点击【开始屏幕分享】按钮
    handleStartScreenShare: function () {
      var _handleStartScreenShare = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!this.sdkAppId || !this.secretKey)) {
                _context5.next = 3;
                break;
              }
              alert("Please enter sdkAppId and secretKey");
              return _context5.abrupt("return");
            case 3:
              _context5.next = 5;
              return this.initShareClient();
            case 5:
              _context5.next = 7;
              return this.initShareLocalStream();
            case 7:
              _context5.next = 9;
              return this.handleShareJoin();
            case 9:
              _context5.next = 11;
              return this.handleSharePublish();
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleStartScreenShare() {
        return _handleStartScreenShare.apply(this, arguments);
      }
      return handleStartScreenShare;
    }(),
    // 点击【停止屏幕分享按钮】
    handleStopScreenShare: function () {
      var _handleStopScreenShare = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.handleShareUnpublish();
            case 2:
              _context6.next = 4;
              return this.handleShareLeave();
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleStopScreenShare() {
        return _handleStopScreenShare.apply(this, arguments);
      }
      return handleStopScreenShare;
    }(),
    // 显示成功的 Log
    addSuccessLog: function addSuccessLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "success",
        log: log
      });
      var scrollHeight = this.$refs.logContainer.scrollHeight;
      this.$refs.logContainer.scrollTop = scrollHeight;
    },
    // 显示失败的 Log
    addFailedLog: function addFailedLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "failed",
        log: log
      });
      var scrollHeight = this.$refs.logContainer.scrollHeight;
      this.$refs.logContainer.scrollTop = scrollHeight;
    },
    reportSuccessEvent: function reportSuccessEvent(name) {
      // this.$aegis.reportEvent({
      //   name,
      //   ext1: `${name}-success`,
      //   ext2: "webrtcQuickDemoVue2",
      //   ext3: this.sdkAppId
      // });
    },
    reportFailedEvent: function reportFailedEvent(name, error) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "rtc";
    } // this.$aegis.reportEvent({
    //   name,
    //   ext1: `${name}-failed#${this.roomId}*${
    //     type === "share" ? this.shareUserId : this.userId
    //   }*${error.message}`,
    //   ext2: "webrtcQuickDemoVue2",
    //   ext3: this.sdkAppId
    // });
  }
};
exports.default = _default;